import React from 'react';
import type { IconProps } from '../types';

export const IconFullscreen = (props: IconProps) => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>fullscreen</title>
    <g
      id="fullscreen"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="fullscreen-icon"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Top-left corner */}
        <polyline
          points="3 8 3 3 8 3"
        />
        {/* Top-right corner */}
        <polyline
          points="12 3 17 3 17 8"
        />
        {/* Bottom-right corner */}
        <polyline
          points="17 12 17 17 12 17"
        />
        {/* Bottom-left corner */}
        <polyline
          points="8 17 3 17 3 12"
        />
      </g>
    </g>
  </svg>
);

export default IconFullscreen;
